import { render, staticRenderFns } from "./FloatingActionPanel.vue?vue&type=template&id=5af10bdc&scoped=true"
import script from "./FloatingActionPanel.vue?vue&type=script&lang=js"
export * from "./FloatingActionPanel.vue?vue&type=script&lang=js"
import style0 from "./FloatingActionPanel.vue?vue&type=style&index=0&id=5af10bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af10bdc",
  null
  
)

export default component.exports